var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { throttle } from "lodash-es";
var namespace = '@@vue-sticky-directive';
var wait = 250;
var Sticky = /** @class */ (function () {
    function Sticky(el, options) {
        this.stuck = false;
        this.el = el;
        this.options = __assign({ mode: "top", placeholderClassName: "", className: "stuck", top: 0, zIndex: 1000 }, options);
        this.originalStyle = {
            position: this.el.style.position,
            top: this.el.style.top,
            left: this.el.style.left,
            right: this.el.style.right,
            zIndex: this.el.style.zIndex
        };
        this.placeholder = document.createElement('div');
        this.placeholder.className = this.options.placeholderClassName;
        this.scrollHandler = throttle(this.onScroll.bind(this), wait);
    }
    Sticky.prototype.inserted = function () {
        this.el.parentNode.insertBefore(this.placeholder, this.el);
        window.addEventListener('scroll', this.scrollHandler);
    };
    Sticky.prototype.bind = function () {
    };
    Sticky.prototype.unbind = function () {
        for (var key in this.originalStyle) {
            this.el.style[key] = this.originalStyle[key];
        }
        this.scrollHandler.cancel();
        window.removeEventListener('scroll', this.scrollHandler);
        delete this.el[namespace];
    };
    Sticky.prototype.onScroll = function () {
        if (this.placeholder.getBoundingClientRect().top <= this.options.top) {
            this.stick();
        }
        else {
            this.unstick();
        }
    };
    Sticky.prototype.stick = function () {
        if (this.stuck)
            return;
        if (this.options.className) {
            this.el.classList.add(this.options.className);
        }
        this.placeholder.style.height = this.stringifyPixels(this.el.offsetHeight);
        this.el.style.position = "fixed";
        this.el.style.top = this.stringifyPixels(this.options.top);
        this.el.style.left = "0";
        this.el.style.right = "0";
        this.el.style.zIndex = this.options.zIndex.toString();
        this.stuck = true;
    };
    Sticky.prototype.unstick = function () {
        if (!this.stuck)
            return;
        if (this.options.className && this.el.classList.contains(this.options.className)) {
            this.el.classList.remove(this.options.className);
        }
        this.placeholder.style.height = null;
        this.el.style.position = null;
        this.el.style.top = null;
        this.el.style.left = null;
        this.el.style.right = null;
        this.el.style.zIndex = null;
        this.stuck = false;
    };
    Sticky.prototype.stringifyPixels = function (value) {
        if (value === 0)
            return "0";
        return value + "px";
    };
    Sticky.set = function (el, value) {
        el[namespace] = value;
    };
    Sticky.get = function (el) {
        return el[namespace];
    };
    return Sticky;
}());
export default {
    inserted: function (el, binding) {
        Sticky.get(el).inserted();
    },
    bind: function (el, binding) {
        var options = { mode: "top" };
        Sticky.set(el, new Sticky(el, __assign({}, options, binding.value)));
        Sticky.get(el).bind();
        // const className = binding.value && 'className' in binding.value ? binding.value.className : "stuck";
        // const stickyTop = binding.value && 'top' in binding.value ? binding.value.top : 0;
        // const zIndex = binding.value && 'zIndex' in binding.value ? binding.value.zIndex : 1000;
        // const handler = throttle(() => {
        // }, 250);
        // el.dataset.stickyHandler = handlers.push(handler) - 1;
        // window.addEventListener('scroll', handler);
    },
    unbind: function (el, binding) {
        Sticky.get(el).unbind();
        // const handlerIndex = el.dataset.stickyHandler as any as number
        // const handler = handlers[handlerIndex];
        // handler.cancel();
        // window.removeEventListener('scroll', handler);
        // delete handlers[handlerIndex];
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/Directives/sticky.ts
// module id = 1020
// module chunks = 24